import { Link } from 'react-router-dom';
import type { CrossLink } from '../lib/crossLinks';

// Renders a row of small pill links next to a CopyButton for an ID that has known
// cross-domain targets (see src/lib/crossLinks.ts). Turns a copy-then-paste-into-another-
// page's-filter workflow into a single click.
export function RelatedLinks({ links }: { links: CrossLink[] }) {
  if (links.length === 0) return null;

  return (
    <span className="related-links">
      {links.map((link) => (
        <Link key={`${link.pathname}${link.search}`} to={{ pathname: link.pathname, search: link.search }} className="related-link">
          {link.label}
        </Link>
      ))}
    </span>
  );
}
